<style>
th {
  padding: 1px; /* Aumenta el espacio dentro de cada celda */
  border: 1px solid #ddd;
}
td {
  padding: 1px; /* Aumenta el espacio dentro de cada celda */
  /* border: 1px solid #ddd; */
}
.div-tabla {
  display: block;
  /*max-height: 200px;*/
  /*overflow-y: auto;*/
  width: 100%;
  display: block;
}
table {
  margin: 0 auto;
  width: 35%;
  border-collapse: separate; /* Necesario para aplicar border-spacing */
  border-spacing: 2px; /* Ajusta el espacio entre las celdas */
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Configuración Código QR</b-card-header>
      <b-card-body>
        <div
          style="font-weight:bold;margin-bottom:10px"
        >Seleccioná los plazos de acreditación con Código QR</div>
        <div>Las opciones varian de acuerdo al plazo seleccionado para recibir tu dinero y se descontarán en tus proximos cobros.</div>

        <div style="margin-top:30px;">
          <div class="text-center" style="font-weight:bold;">Dinero en cuenta</div>
          <div class="div-tabla">
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>Plazo</th>
                  <th>Costo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in qrConfigurationList" :key="index">
                  <td>
                    <input
                      type="radio"
                      v-model="item.seleccionado"
                      :name="item.id+'sel'"
                      value="true"
                      @click="SelectOption(qrConfigurationList, item)"
                    />
                  </td>
                  <td>{{ item.plazo }}</td>
                  <td>{{ item.costo }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div
          style="font-weight:bold; margin-top:50px"
        >Las comisiones son expresadas sin IVA incluido y el plazo es en días hábiles para la acreditación del pago en tu cuenta.</div>
        <div class="text-center" style="padding-top:10px">
          <b-button class="btn btn-danger" @click="goBack()">
            <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
          </b-button>
          <button class="btn btn-success" type="button" @click="SaveButtonClick()">Guardar</button>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
  name: "SmartPost",
  data() {
    return {
      QrMoneyInAccountPaymentMethodID: 0,
      qrConfigurationList: []
    };
  },
  methods: {
    initialize() {
      let context = this;

      context.QrMoneyInAccountPaymentMethodID =
        context.$store.getters.ID_QR_MONEY_IN_ACCOUNT_PAYMENT_METHOD;
    },
    goBack() {
      this.$router.push("ConfiguracionCostos");
    },
    SaveButtonClick() {},
    SelectOption(ConfigurationList, Configuration) {
      ConfigurationList.forEach(x => {
        x.seleccionado = false;
      });
      Configuration.seleccionado = true;
    },
    GetInfoAutomaticCommissions() {
      let context = this;

      context.qrConfigurationList = [];

      axiosHelpers.axiosGet(
        "OperationsFintouch/GetInformationAutomaticCommissions",
        {},
        context,
        function(response) {
          var items = response.ResponseVM.Items;

          var id = 1;
          items.forEach(x => {
            if (x.PaymentMethodID == context.QrMoneyInAccountPaymentMethodID) {
              context.qrConfigurationList.push({
                id: id,
                MethodID: x.MethodID,
                PaymentMethodID: x.PaymentMethodID,
                plazo: x.Description,
                costo: x.Percentage + "% + IVA",
                seleccionado: x.Enabled
              });
            }

            id++;
          });
        }
      );
    },
    SaveButtonClick() {
      let context = this;

      var request = {
        Items: []
      };

      context.qrConfigurationList.forEach(x => {
        request.Items.push({
          AdvanceConfigurationMethodID: x.MethodID,
          Enabled: x.seleccionado
        });
      });

      axiosHelpers.axiosPost(
        "OperationsFintouch/SaveAutomaticCommissions",
        request,
        context,
        function(response) {
          if (response.ResponseVM.Result) {
            context.$router.push({
              name: "ConfiguracionCostos"
            });
          }
        }
      );
    }
  },
  beforeMount() {
    this.initialize();
    this.GetInfoAutomaticCommissions();
  }
};
</script>